<div class="responsive-card d-flex flex-column gap-3" [style.width.rem]="24.3">
  <span class="responsive-card-title" i18n>Member Overview</span>
  <ng-container *ngIf="!isLoading; else loading">
    <div class="d-flex flex-column gap-2">
      <span class="status-label" i18n>Member Status</span>
      <div class="status-container">
        <div class="d-flex flex-column gap-1">
          <div class="status-name">{{ member?.fullName }}</div>
          <div class="status-id">{{ member?.id | leadingZero : 8 }}</div>
        </div>
        <app-status-pill class="mt-auto mb-auto" [statusPill]="member?.statusPill" />
      </div>
    </div>
    <div class="d-flex flex-column gap-2" *ngIf="member?.employmentHistory?.length">
      <span class="status-label" i18n>Employment Status</span>
      <div class="status-container" *ngFor="let hist of member?.employmentHistory">
        <div class="d-flex flex-column gap-1">
          <div class="status-name">{{ hist?.employer }}</div>
          <div class="status-id">{{ hist?.employerId | leadingZero : 8 }}</div>
        </div>
        <app-status-pill class="mt-auto mb-auto" [statusPill]="hist?.employmentStatusId | employmentStatusPill" />
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loading>
  <div class="d-flex flex-column gap-2">
    <span class="status-label" i18n>Member Status</span>
    <div class="status-container">
      <lib-loading-shimmer [height]="'1.25rem'" [width]="'10rem'" />
      <lib-loading-shimmer [height]="'1.25rem'" [width]="'5rem'" />
    </div>
  </div>
  <div class="d-flex flex-column gap-2">
    <span class="status-label" i18n>Employment Status</span>
    <div class="status-container">
      <lib-loading-shimmer [height]="'1.25rem'" [width]="'10rem'" />
      <lib-loading-shimmer [height]="'1.25rem'" [width]="'5rem'" />
    </div>
  </div>
</ng-template>
